import { Point } from '../types';
import { computeDistance, isInBoundingBox } from './location-utils';
import { MapData } from './map-data';

export class LocationSearchResult {
  constructor(
    public label: string,
    public referencePoint?: Point,
    public boundingBox?: number[][],
    public _placeLocation?: Point,
    public mapData?: MapData
  ) {}

  static fromMapData(mapData: MapData, referencePoint?: Point): LocationSearchResult {
    // All datasources are within the bounding box, so we don't need it here.
    return new LocationSearchResult(mapData.datasourceName, referencePoint, undefined, undefined, mapData);
  }

  static fromPlacesResult(
    displayName: string,
    location: Point,
    referencePoint?: Point,
    boundingBox?: number[][]
  ): LocationSearchResult {
    return new LocationSearchResult(displayName, referencePoint, boundingBox, location);
  }

  // higher score means better match
  get rankingScore(): number {
    // let score = this.isDatasourceSearchResult ? 10 : 1 - Number(this.isOutOfBounds);
    let score = 1 - Number(this.isOutOfBounds) + (this.isDatasourceSearchResult ? 0.01 : 0);
    if (this.referencePoint) {
      // Penalize locations further away from the reference point
      const EARTH_CIRCUMFERENCE_KM = 40_075.017;
      score += 1 - computeDistance(this.referencePoint, this.location, 'kilometers') / EARTH_CIRCUMFERENCE_KM;
    }
    return score;
  }

  get isDatasourceSearchResult(): boolean {
    return !!this.mapData;
  }

  get location(): Point {
    return this._placeLocation ?? this.mapData!.marker.location;
  }

  get isOutOfBounds(): boolean {
    return this.boundingBox ? !isInBoundingBox(this.boundingBox, this.location.coordinates) : false;
  }
}
